import React from "react";
import clsx from "clsx";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import LinkOffIcon from "@material-ui/icons/LinkOff";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(() => ({
  badge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    padding: "0px 4px",
    borderRadius: 4,
    backgroundColor: "#9e9e9e",
    color: "#fff",
    fontSize: "0.65rem",
    fontWeight: "bold",
    lineHeight: 1.5,
    textTransform: "uppercase",
    whiteSpace: "nowrap",
    overflow: "hidden",
    minWidth: 0,
    "& svg": {
      fontSize: 13,
      flexShrink: 0,
    },
  },
  compact: {
    padding: 3,
    borderRadius: 3,
    justifyContent: "center",
  },
  label: {
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}));

// Selo dos tickets de conexão excluída (Tickets.active = 0): só leitura, visível
// apenas para admin/super. `ticket.whatsapp` vem nulo nesses tickets (conexão em
// soft delete), por isso o selo substitui o chip/badge da conexão.
const InactiveConnectionBadge = ({ ticket, inactivatedAt, compact = false, className, style }) => {
  const classes = useStyles();
  const date = inactivatedAt ?? ticket?.inactivatedAt;
  const parsed = date ? moment(date) : null;
  const label = i18n.t("tickets.inactiveConnection.badge");
  const tooltip = parsed?.isValid()
    ? i18n.t("tickets.inactiveConnection.tooltip", { date: parsed.format("DD/MM/YYYY HH:mm") })
    : label;

  return (
    <Tooltip arrow placement="top" title={tooltip}>
      <span className={clsx(classes.badge, compact && classes.compact, className)} style={style}>
        <LinkOffIcon />
        {!compact && <span className={classes.label}>{label}</span>}
      </span>
    </Tooltip>
  );
};

export default InactiveConnectionBadge;
